export default defineNuxtRouteMiddleware(to => {
  if (to.query.preview) {
    const query = { ...to.query }
    if (to.params.slug) {
      query.slug = to.params.slug
    }

    return navigateTo({ path: "/preview", query })
  }
})
